import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListTypeStructureComponent } from './list-typeStructure/list-typeStructure.component';
import { FilterTypeStructureByNamePipe } from 'src/app/shared/pipes/filter-typeStructure-by-name/filter-typeStructure-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { TypeStructureModalDetailComponent } from './modal/typeStructure-modal-detail/typeStructure-modal-detail.component';
import { TypeStructureModalAjoutComponent } from './modal/typeStructure-modal-ajout/typeStructure-modal-ajout.component';

@NgModule({
	declarations: [
		ListTypeStructureComponent,
		TypeStructureModalDetailComponent,
		TypeStructureModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterTypeStructureByNamePipe]
})

export class TypeStructureModule {}
